var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { MENU_ITEMS, CART, MENU_OPTIONS, CART_OPTION } from '@/stores/defs';
import OptionExceptionModel from '@/models/OptionExceptionModel';
import cartItemPriceMixin from '@/components/mixins/cartItemPriceMixin';
import optionValidatorMixin from '@/components/mixins/optionValidatorMixin';
import discountMixin from '@/components/mixins/discountMixin';
import upsellMixin from '@Mixin/upsellMixin';
import bundleMixin from '@Mixin/bundleMixin';
import couponMixin from '@Mixin/couponMixin';
import headerMixin from '@Mixin/headerMixin';
import routeMixin from '@Mixin/routeMixin';
var itemDetailMixin = {
    mixins: [
        cartItemPriceMixin,
        optionValidatorMixin,
        discountMixin,
        upsellMixin,
        bundleMixin,
        couponMixin,
        headerMixin,
        routeMixin,
    ],
    computed: __assign({}, mapGetters({
        cartItem: CART.GET_CURRENT_ITEM,
        quantity: CART.ITEM_QUANTITY,
        getItem: MENU_ITEMS.GET_ITEM,
        menuHasItems: MENU_ITEMS.HAS_ITEMS,
        getOption: MENU_OPTIONS.GET_OPTION,
        validateCartOptions: CART_OPTION.VALIDATE_OPTIONS,
    }), { _isOutOfStock: function () {
            var cartItem = this.cartItem;
            // @ts-ignore
            var menuItem = this.getItem(cartItem.id);
            if (!menuItem) {
                return false;
            }
            return menuItem.outOfStock;
        } }),
    methods: __assign({}, mapActions({
        fetchItems: MENU_ITEMS.FETCH_ALL,
        setCartItem: CART.SET_CURRENT_ITEM,
        increment: CART.INCREMENT_CURRENT,
        decrement: CART.DECREMENT_CURRENT,
        setCurrentItemQuantity: CART.SET_CURRENT_ITEM_QUANTITY,
    }), { getItemRestrictionTxt: function (item, discount) {
            var _this = this;
            if (item === void 0) { item = null; }
            if (discount === void 0) { discount = null; }
            var description = '';
            if (!item || !discount || (discount && !discount.groups)) {
                return description;
            }
            var group = discount.groups[0];
            group.options.forEach(function (option) {
                var matchingId = item.getMatchingId(option.asset_id);
                if (matchingId) {
                    var exceptionModel = new OptionExceptionModel(__assign({}, option.option_exception, { hydrationStrategy: 'hydrateForCoupon' }));
                    // need to convert ids to local ids or options won't be found
                    if (!discount.isLocal) {
                        exceptionModel.convertFranchiseOptionIdsToLocal();
                    }
                    if (exceptionModel.masterOption && exceptionModel.masterOption.defaultChoices) {
                        if (exceptionModel.masterOption.allChoicesIncluded()) {
                            description = '';
                        }
                        else {
                            var defaultChoices = exceptionModel.masterOption.defaultChoices;
                            var storeOption = _this.getOption(exceptionModel.id);
                            if (storeOption) {
                                var includedNames = [];
                                for (var id in defaultChoices) {
                                    var choice = storeOption.getExistingChoice({ choice_id: defaultChoices[id].id });
                                    if (defaultChoices[id].included) {
                                        includedNames.push(choice.name);
                                    }
                                }
                                // if there is 1+ items that are not the same
                                if (includedNames.length !== Object.keys(defaultChoices).length) {
                                    description += storeOption.name + ": " + includedNames.join(', ');
                                }
                            }
                        }
                    }
                }
            });
            return description;
        },
        disabledForBundle: function () {
            if (!this.getBundle) {
                return true;
            }
            if (!this.bundleReady) {
                return true;
            }
            return false;
        },
        isReadyForBundle: function () {
            return (this.getBundle && this.bundleReady);
        },
        validPrice: function () {
            var total = this.getTotal();
            // reqs for bundle
            var bundle = this.getBundle;
            if (bundle) {
                total = this.getDiscountedPrice;
                // TODO this is an arbitrary amount of $1
                // could be config.
                return (total >= 100);
            }
            var freeChoices = this.cartItem.freeChoices;
            if (freeChoices) {
                return (total >= 0);
            }
            // reqs for item with options
            var cartOptions = this.cartItemOptions;
            if (cartOptions.length > 0) {
                // TODO this is an arbitrary amount of 99¢
                // could be config.
                return (total >= 99);
            }
            // free items
            return (total >= 0);
        } }),
};
export default itemDetailMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/itemDetailMixin.ts
// module id = 6pBE
// module chunks = 18